import { ScanLine, TrendingUp, FileText, Truck, Clock, PiggyBank } from "lucide-react";

const FEATURES = [
  {
    icon: ScanLine,
    title: "AI item identification",
    text: "Recognises brand, model, condition cues and category from a single photo.",
    testId: "feature-ai-identification",
  },
  {
    icon: TrendingUp,
    title: "Smart price estimates",
    text: "Price suggestions backed by real sold comparables, so you list at a number that moves.",
    testId: "feature-price-estimates",
  },
  {
    icon: FileText,
    title: "Ready-made listings",
    text: "Title, description and item specifics written for eBay, Facebook and Gumtree formats.",
    testId: "feature-ready-listings",
  },
  {
    icon: Truck,
    title: "Direct eBay publishing",
    text: "Post straight to eBay from the app, with calculated shipping handled for you.",
    testId: "feature-ebay-publishing",
  },
  {
    icon: Clock,
    title: "Sold insights",
    text: "Estimated days-to-sell for your item, based on how similar listings performed.",
    testId: "feature-sold-insights",
  },
  {
    icon: PiggyBank,
    title: "Profit tracking dashboard",
    text: "See what you listed, what sold and what you actually made — all in one place.",
    testId: "feature-profit-tracking",
  },
];

const Features = () => (
  <section id="features" data-testid="features-section" className="section-anchor py-24">
    <div className="mx-auto max-w-6xl px-4 sm:px-6">
      <p className="font-display text-sm font-semibold uppercase tracking-widest text-brand-light">Features</p>
      <h2 className="mt-3 max-w-2xl font-display text-3xl font-bold uppercase tracking-wide text-onsurface sm:text-4xl">
        Everything between the photo and the sale
      </h2>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map(({ icon: Icon, title, text, testId }) => (
          <div
            key={testId}
            data-testid={testId}
            className="rounded-lg border border-line bg-surface2 p-8 transition-all duration-200 hover:-translate-y-1 hover:border-brand-light/60"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-tint">
              <Icon className="h-6 w-6 text-brand-tinttext" />
            </div>
            <h3 className="mt-6 font-display text-lg font-semibold uppercase tracking-wide text-onsurface">{title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-onsurface2">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Features;
